<template>
  <div>
    <el-button @click="click"  type="primary" icon="el-icon-search" :loading="loading">{{content}}</el-button>
  </div>
</template>
<script>
  export default{
    name: 'load-button',
    props: ['text','can-click'],
    data(){
      return {
        loading: false,
        content: this.text || '搜索'
      }
    },
    methods: {
      click(){
        if(!this.loading){
          this.loading = true
          this.$emit('on-click',this.cancel)
        }
      },
      cancel(){
          this.loading = false
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/LoadButton.vue